import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentImageUploadService } from 'src/app/services/component-image-upload.service';
import { ProductServiceService } from 'src/app/services/product-service.service';
import { TemplateMasterService } from 'src/app/master_modules/masters/apps/template/template-master.service';
import { Observable, startWith, map } from 'rxjs';
import { FormControl } from '@angular/forms';
import { SearchProductComponent } from '../search-product/search-product.component';

@Component({
  selector: 'app-create-collection',
  templateUrl: './create-collection.component.html',
  styleUrls: ['./create-collection.component.scss']
})
export class CreateCollectionComponent {
  productData: any;
  constructor(
    public dialogRef: MatDialogRef<CreateCollectionComponent>,
    public ds: DomSanitizer,
    private imageUploadService: ComponentImageUploadService,
    private snackBar: MatSnackBar,
    private productService: ProductServiceService,
    private templateService: TemplateMasterService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.getScreenSize();
  }

  srcHeight: any;
  srcWidth: any;
  itemName: any;
  searchControl = new FormControl('');
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.srcHeight = window.innerHeight;
    this.srcWidth = window.innerWidth;
  }

  closebutton() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.getEcommerceIndustry();
    this.getProductList();
    this.getAllCollections(); //  fetch all collections for duplicate check

    if (this.data.edit === true) {
      this.CollectionData.collectionName = this.data.data.collectionName;
      this.CollectionData.description = this.data.data.description;
      this.addedProductIds = this.data.data.itemIds;
      this.nodeAttachements = this.data.data.imgUrl?.map((url) => ({
        url: url,
        attachmentType: 'IMAGE',
        isAlreadyUploaded: true
      }));
    }

    this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterProducts(value || ''))
    ).subscribe(filtered => {
      this.filteredProducts = filtered;
    });
  }

  filterProducts(search: string) {
    const filterValue = search.toLowerCase();
    return this.productsData.filter(product =>
      product.name?.toLowerCase().includes(filterValue)
    );
  }

  pageLoader: boolean = false;
  nodeAttachements: any = [];
  categorieData: any = {}
  allCollections: any[] = []; //  store all collections

  updateContactImage(ev: any) {
    this.pageLoader = true;
    for (const fileData of ev.srcElement.files) {
      const reader = new FileReader();
      reader.onload = (response: any) => {
        this.nodeAttachements.push({
          url: response.target.result,
          name: fileData.name,
          attachmentType: fileData.type.includes('image') ? 'IMAGE' : (fileData.type == "application/pdf" ? 'FILE' : ''),
          file: fileData
        })
      }
      reader.readAsDataURL(fileData);
    }
    this.pageLoader = false;
  }

  CollectionData: any = {
    subIndustryId: '',
    collectionName: '',
    description: '',
    imgUrl: [],
    itemIds: []
  }

  delete(index: any) {
    this.nodeAttachements.splice(index, 1)
  }

  collectionName: any;
  description: any;
  showOnlineStore: boolean = false;
  submitLoader: boolean = false;
  filteredProducts: any = [];

  //  Duplicate check & create collection
  async createCollections() {
    this.submitLoader = true;
    // --- Validate max length for collection name ---
if ((this.CollectionData.collectionName || '').length > 50) {
  this.submitLoader = false;
  this.snackBar.open('Collection Name cannot exceed 50 characters', 'close', { duration: 2000 });
  return;
}
const invalidCharPattern = /[^a-zA-Z0-9\s&'-]/;
if (invalidCharPattern.test(this.CollectionData.collectionName || '')) {
  this.submitLoader = false;
  this.snackBar.open('Collection Name contains invalid characters. Only letters, numbers, spaces, &, and - are allowed.', 'close', { duration: 2500 });
  return;
}
    // --- Duplicate check only when creating ---
    if (!this.data.edit) {
      const newName = (this.CollectionData.collectionName || '').trim().toLowerCase();
      const duplicate = this.allCollections.some(
        (c: any) => (c.collectionName || c.name || '').trim().toLowerCase() === newName
      );

      if (duplicate) {
        this.submitLoader = false;
        this.snackBar.open('Collection already exists!', 'close', { duration: 1500 });
        return; // stop API call
      }
    }

    // --- Upload images if any ---
    let imageUrls: string[] = [];
    for (let item of this.nodeAttachements) {
      if (!item.file) {
        imageUrls.push(item.url);
        continue;
      }
      let imageResponse: any;
      imageResponse = await this.imageUploadService.uploadComponentsImages(item.file, "product_image");
      imageUrls.push(imageResponse['Location']);
    }

    this.CollectionData.imgUrl = imageUrls;
    if (this.data.edit) {
      this.CollectionData.collectionId = this.data.data.collectionId;
    }

    // --- Call API to save ---
    this.productService.addNewCollection(this.CollectionData).subscribe({
      next: (res: any) => {
        this.submitLoader = false;
        this.getAllCollections(); //  refresh list
        this.dialogRef.close();

        if (this.data.edit) {
          this.snackBar.open('Collection Updated Successfully', 'close', { duration: 1000 });
        } else {
          this.snackBar.open('Collection Created Successfully', 'close', { duration: 1000 });
        }
      },
      error: (err: any) => {
        this.submitLoader = false;
        this.snackBar.open(err.message, 'close', { duration: 500 });
        console.error('Error:', err);
      }
    });
  }

  async UpdateCategories() { }

  ecomIndustry: any = [];
  ecomMyControl = new FormControl();
  ecomFilteredOptions: Observable<string[]> | any;

  getEcommerceIndustry() {
    this.templateService.getAllEcommerceIndustries().subscribe((res: any) => {
      res.data.forEach((data: any) => {
        this.ecomIndustry.push({
          name: data.name,
          industryId: data.parent.id,
          subIndustryId: data.id,
          industryName: data.parent.name,
          subIndustryName: data.name,
        });
      });
      if (this.data.edit) {
        this.editIndustry = this.ecomIndustry.find(industry => industry.subIndustryId === this.data.data.subIndustryId);
        this.selectBusinessType(this.editIndustry);
      }
      if (!this.data.edit) {
        if (this.ecomIndustry.length > 0) {
          const defaultOption = this.ecomIndustry[0];
          this.ecomMyControl.setValue(defaultOption.name);
          this.selectBusinessType(defaultOption);
        }
      }
      this.ecomFilteredOptions = this.ecomMyControl.valueChanges.pipe(
        startWith(''),
        map((value) => this._ecomFilter(value))
      );
    });
  }

  editIndustry: any;
  selectBusinessType(ev: any) {
    this.addedProductIds = [];
    this.CollectionData.itemIds = [];
    this.productsChips = [];
    this.categorieData.subIndustryId = ev.subIndustryId;
    this.CollectionData.subIndustryId = ev.subIndustryId
    this.categorieData.subIndustryName = ev.name;
    this.ecomMyControl.setValue(ev.name);
    this.getProductList();
  }

  deleteAllChips() {
    if (this.CollectionData.itemIds.length > 0) {
      this.productsChips = [];
      this.addedProductIds = [];
      this.CollectionData.itemIds = [];
    }
    else {
      this.filteredProducts.forEach((product: any) => {
        this.productsChips.push({ name: product.name, id: product.itemId });
        this.addedProductIds.push(product.itemId);
        this.CollectionData.itemIds = this.addedProductIds;
      })
    }
  }

  onSubIndustryChange(subIndustryName: any) {
    const selectedOption = this.ecomIndustry.find(option => option.name === subIndustryName);
    if (selectedOption) {
      this.selectBusinessType(selectedOption);
    }
  }

  private _ecomFilter(value: any) {
    const filterValue = value.toLowerCase();
    return this.ecomIndustry.filter((option: any) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  itemDataSource: any[] = []
  getProductListByCollection(element: any) {
    let data = {
      collectionId: element.collectionId,
    }
    this.productService.getProductListByCollection(data.collectionId).subscribe(
      {
        next: (res: any) => {
          this.itemDataSource = res.data;
        }
      }
    )
  }

  openDialog() {
    let searchDialog = this.templateService.openDialog(
      SearchProductComponent,
      '69vh',
      '40%',
      {
        selectedProductIds: this.CollectionData.itemIds,
      }
    );
    searchDialog.afterClosed().subscribe((res: any) => {
      this.CollectionData.itemIds = res.productIds;
    })
  }

  productsData: any[] = [];
  getProductList() {
    var payload = {
      subId: this.CollectionData.subIndustryId,
      pageNo: 0,
      pageSize: 10000
    }
    this.productService.getProductList(payload).subscribe(
      {
        next: (res: any) => {
          this.productsData = res.data.data;
          this.filteredProducts = this.productsData;
        }
      }
    )
  }

  addedProductIds: String[] = [];
  productsChips: any[] = [];
  addProduct(checkBox, product: any) {
    if (checkBox.checked) {
      if (!this.addedProductIds.includes(product.itemId)) {
        this.addedProductIds.push(product.itemId);
      }
    } else {
      this.addedProductIds = this.addedProductIds.filter((ref) => ref !== product.itemId);
    }
    this.CollectionData.itemIds = this.addedProductIds;
    this.productsChips = [];
    if (this.CollectionData.itemIds.length > 0) {
      this.CollectionData.itemIds.forEach((prodId) => {
        this.filteredProducts.forEach((prod) => {
          if (prodId == prod.itemId) {
            this.productsChips.push({ name: prod.name, id: prod.itemId });
          }
        })
      })
    }
  }

  getSelectedProductNames(): string {
    if (!this.productData || this.CollectionData.itemIds.length === 0) return '';
    return this.productData.data.filter(p => this.CollectionData.itemIds.includes(p.itemId))
      .map(p => p.name)
      .join(', ');
  }

  deleteChip(product: any, index: any) {
    this.addedProductIds = this.addedProductIds.filter((ref) => ref !== product.id);
    this.CollectionData.itemIds = this.addedProductIds;
    this.productsChips.splice(index, 1);
  }

  
  getAllCollections() {
    this.productService.getCollectionList({ pageNo: 0, pageSize: 1000 }).subscribe({
      next: (res: any) => {
        this.allCollections = res?.data?.data || res?.data || [];
      },
      error: (err: any) => {
        console.error('Error fetching collections:', err);
      }
    });
  }
}
